import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { OroService, EventTyp } from '../oroservice';

@Component({
    selector: 'app-postal-code',
    templateUrl: './postal-code.component.html',
    styleUrls: ['./postal-code.component.scss'],
    standalone: false
})
export class PostalCodeComponent implements OnInit {
    @Input()
    Ort: any;
    @Input()
    Land: any;
    @Input()
    Plz: any;

    @Input()
    Marginfull: boolean = false;
    @Input()
    OnlyCH: boolean = false;

    @Output() PlzChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() OrtChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() LandChange: EventEmitter<any> = new EventEmitter<any>();

    plzinfolisteFull = [];
    plzinfolisteFilter = [];
    constructor(public oroservice: OroService) { }

    ngOnInit() {
        try {
            this.oroservice.getPlz().subscribe((data: []) => {
                this.plzinfolisteFull = data;
                this.plzinfolisteFilter = data;
                this.checkplz();
            });
        } catch (ex) {
            console.log("Error: " + ex);
        }

    }

    checkplz() {
        if (this.Land == 0) {
            if (this.Plz && this.Plz.length == 4) {
                this.oroservice.getOrtList(this.Plz).then(res => {
                    this.plzinfolisteFilter = res;

                    if (this.plzinfolisteFilter.length > 0) {
                        this.Ort = this.plzinfolisteFilter[0].Ort;
                    } else {
                        this.Ort = "";
                    }
                    this.ortchange();
                }).catch((error) => {
                    //return this.handleerror(error);
                });
            } else {
                if (!this.Plz || this.Plz.length < 4) {
                    this.Ort = "";
                    this.plzinfolisteFilter = null;
                } else {
                    this.Plz = this.Plz.substring(0, 4);
                }

                this.ortchange();
            }

            this.plzchange();
        } else {
            if (this.Plz == null) {
                this.Ort = "";
            }

            this.plzchange();
            this.ortchange();
        }
    }

    landchange() {
        this.LandChange.emit(this.Land);
    }

    plzchange() {
        this.PlzChange.emit(this.Plz);
    }

    ortchange() {
        this.OrtChange.emit(this.Ort);
    }
}
